import React, { useEffect } from 'react'

import { Styles } from '../base/Styles'
import { Page } from '../base/Page'
import { firebaseApp } from '../firebase'
import { ref, getDatabase, set } from 'firebase/database'
import { useList } from 'react-firebase-hooks/database'
import { InputText } from '../base/InputText'
import * as Yup from 'yup'
import { useYupValidationResolver } from '../base/validateResolver'
import { useForm } from 'react-hook-form'
import { Card } from 'flowbite-react'
import { DB } from '../DB'
import { DeliveryCharge } from '../model/Settings'
import toast from 'react-hot-toast'

const formSchema = Yup.object().shape({
  range: Yup.string().required(),
  deliveryCharge: Yup.string().required(),
  doorDeliveryCharge: Yup.string().required(),
})

const database = getDatabase(firebaseApp)

export default function DeliveryCharges() {
  const [snapshots, loading, error] = useList(ref(database, DB.deliveryCharges))
  const [data, setData] = React.useState<DeliveryCharge[]>([])
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm<DeliveryCharge>({ resolver: useYupValidationResolver(formSchema) })

  useEffect(() => {
    if (snapshots) {
      setData(snapshots.map((s) => s?.toJSON() as DeliveryCharge))
    }
  }, [snapshots])

  const onSubmit = (data: DeliveryCharge) => {
    set(ref(database, DB.deliveryCharges + '/r' + data.range), data)
    reset()
    toast.success('Delivery Charge Saved')
  }

  return (
    <Page title='Delivery Charges'>
      <Card>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className='flex flex-row gap-2 items-center justify-center border-b-2  border-dotted py-1'>
            <InputText
              {...register('range')}
              name={'range'}
              label='Range'
              error={errors.range?.message}
            />
            <InputText
              {...register('deliveryCharge')}
              name={'deliveryCharge'}
              label='deliveryCharge'
              error={errors.deliveryCharge?.message}
            />
            <InputText
              {...register('doorDeliveryCharge')}
              name={'doorDeliveryCharge'}
              label='doorDeliveryCharge'
              error={errors.doorDeliveryCharge?.message}
            />
            <button type='submit' className={Styles.button.default}>
              Save
            </button>
          </div>
        </form>
        {error && <>Error: {error}</>}
        {loading && <span>List: Loading...</span>}
        {!loading && (
          <>
            <div className='grid grid-cols-4 gap-2 w-full'>
              {data?.map((d) => {
                // eslint-disable-next-line react/jsx-key
                return (
                  <>
                    <div className='py-1 border-b-2 flex items-center'>{d.range}</div>
                    <div className='py-1 border-b-2 flex items-center'>{d.deliveryCharge}</div>
                    <div className='py-1 border-b-2 flex items-center'>{d.doorDeliveryCharge}</div>
                    <div className='py-1 border-b-2 flex items-center'>
                      <button
                        className={Styles.button.link}
                        onClick={() => {
                          setValue('range', d.range)
                          setValue('deliveryCharge', d.deliveryCharge)
                          setValue('doorDeliveryCharge', d.doorDeliveryCharge)
                        }}
                      >
                        Edit
                      </button>
                    </div>
                  </>
                )
              })}
            </div>
          </>
        )}
      </Card>
    </Page>
  )
}
